Model = require('./result-model')

module.exports = class ResultSalesforceUsersCollection extends Backbone.Collection

  model: Model